$(document).ready(function () {
      // Считаем количество слайдов внутри .process-slider
      var slidesCount = $('.process-slider .process-slider__slide').length;

      // Инициализация Slick
      $('.process-slider').slick({
        dots: false,          // точки навигации на десктопе
        infinite: false,     // без бесконечной прокрутки
        speed: 1000,         // скорость анимации (мс)
        slidesToShow: 2.37,  // одновременно видно ~2.37 слайда
        slidesToScroll: 2,   // прокручивать по 2 слайда
        vertical: false,     // горизонтальный режим
        arrows: false,       // без стрелок
        draggable: true,     // перетаскивание мышью/тачем включено

        // Адаптивные настройки
        responsive: [
          {
            breakpoint: 992, // при ширине < 992px
            settings: {
              dots: false,           // отключаем точки
              slidesToShow: slidesCount, // показать все слайды (вертикальный список)
              slidesToScroll: 2,
              vertical: true,        // вертикальный режим
              verticalSwiping: true, // вертикальные свайпы
              arrows: false,
              draggable: false       // фиксированный список (без drag)
            }
          }
        ]
      });
    });

    $('.case__hero-slider').slick({
      dots: true,          // точки навигации на десктопе
      infinite: false,     // без бесконечной прокрутки
      speed: 1000,         // скорость анимации (мс)
      slidesToShow: 1,  // одновременно видно ~2.37 слайда
      slidesToScroll: 1,   // прокручивать по 2 слайда
      vertical: false,     // горизонтальный режим
      arrows: false,       // без стрелок
      draggable: true,     // перетаскивание мышью/тачем включено
      autoplay: true,
      autoplaySpeed: 3000 // 5 секунд
    })

    $('.case__feature-slider').slick({
      dots: true,          // точки навигации на десктопе
      infinite: false,     // без бесконечной прокрутки
      speed: 1000,         // скорость анимации (мс)
      slidesToShow: 1,  // одновременно видно ~2.37 слайда
      slidesToScroll: 1,   // прокручивать по 2 слайда
      vertical: false,     // горизонтальный режим
      arrows: false,       // без стрелок
      draggable: true,     // перетаскивание мышью/тачем включено
      autoplay: true,
      autoplaySpeed: 3000 // 5 секунд
    })

    $('.case__team-slider').slick({
      dots: true,          // точки навигации на десктопе
      infinite: false,     // без бесконечной прокрутки
      speed: 1000,         // скорость анимации (мс)
      slidesToShow: 1,  // одновременно видно ~2.37 слайда
      slidesToScroll: 1,   // прокручивать по 2 слайда
      vertical: false,     // горизонтальный режим
      arrows: false,       // без стрелок
      draggable: true,     // перетаскивание мышью/тачем включено
      autoplay: true,
      autoplaySpeed: 3000 // 5 секунд
    })